export default "__VITE_ASSET__5c68edc4__"